import wx from 'weixin-jsapi'
import { api } from '../app'
import { common } from "../common";
class WxShare {
    async getConfig(meetingId: number) {
        // 进行签名的时候  Android 不用使用之前的链接， ios 需要
        let signLink = window.location.href;
        let { result } = await (api as any).getShare(signLink);

        // id: 43
        // meetid: 568
        // title: "asdasdasd"
        // link: "http://www.baidu.com"
        // desc: "欢迎参加会议~"
        // icon: "https://file-test.huibaifen.com/c05ef20200920022941844

        if (result) {
            wx.config({
                debug: false,
                appId: result.appid,
                timestamp: result.timestamp,
                nonceStr: result.noncestr,
                signature: result.signature,
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'previewImage',
                    'chooseWXPay',
                ]
            });
            wx.ready(async function () {
                const { result } = await (api as any).getMeetingShare(`${meetingId}?time=${new Date().getTime()}`);
                wx.onMenuShareAppMessage({
                    title: result.title,            // 分享标题
                    desc: result.desc,              // 分享描述
                    link: result.link !== '' ? result.link : window.location.href,     // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    // link: 'https://www.baidu.com',
                    imgUrl: result.icon,            // 分享图标
                    success: function () {
                        // alert(JSON.stringify("success"));
                    },
                    cancel: function () {
                        // alert(JSON.stringify("fail"));
                    }
                } as any);
                // wx.updateAppMessageShareData({...data, desc: this.shareDesc});

                //分享到朋友圈
                wx.onMenuShareTimeline({
                    imgUrl: result.icon,
                    link: result.link !== "" ? result.link : window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    // link: "https://www.baidu.com",
                    title: result.title, // 分享标题
                    success: () => { },
                    cancel: () => { },
                });
            });
            wx.error(function (err: any) {
                common.sentry.captureException(err)
            })
        }
    }
}

export const wxShare = new WxShare();
